import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/marketplace/[id]/page.tsx");
